<template>
  <div class="home-container">
    <div class="after-login " v-if="isLogin">
      <div class="left">
        <p class="title">
          <b :class="{ active: activeTitle === 1 }" @click="activeTitle = 1">待审批</b>
          <b :class="{ active: activeTitle === 2 }" @click="activeTitle = 2">申请记录</b>
          <span @click="checkMore">查看更多 》</span>
        </p>
        <div class="divider"></div>
        <div class="table">
          <div class="table-header">
            <b>服务名称</b>
            <b>服务分类</b>
            <b v-if="activeTitle === 1">申请人</b>
            <b v-else>审批状态</b>
            <b>申请时间</b>
          </div>
          <div class="table-row"
            v-for="item in activeTitle === 1 ? userData.todoApplyInfo.applyList : userData.userApplyInfo.userApplyList">
            <span>{{ item.employName }}</span>
            <span>{{ item.categoryName }}</span>
            <span v-if="activeTitle === 1">{{ item.userName }}</span>
            <span class="status" v-else>
              <b
                :style="{ '--color': ['var(--mainColor)', 'var(--successColor)', 'var(--dangerColor)', 'var(--warningColor)', 'var(--warningColor)', 'var(--dangerColor)'][item.approvalStatus - 1] }">{{
                  ['审批中', '已通过', '未通过', '已撤销 ', '挂起 ', '已结束'][item.approvalStatus - 1] }}</b></span>
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>

      <div class="right">
        <b>我的收藏</b>
        <div id="service" v-for="item in userData.userCollectEmployList" :key="item.employId"
          @click="$router.push(`guide?employId=${item.employId}`)">
          <p>
            <i :class="`el-icon-${item.icon}`"></i>
            <span>{{ item.employName }}</span>
            <span>{{ ['线下办理', '线上办理', '线上线下结合'][item.handleWay - 1] }}</span>
          </p>
          <div>
            <span>{{ item.departmentName }}</span>
            <el-tooltip placement="left" content="取消收藏" effect="light">
              <img src="../../assets/星星.png" alt="" width="24" @click.stop="collectService(item.employId)">
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="home-inner">
      <div class="part hot" data-title="热门服务" style="--top:-38px">
        <div id="service" v-for="item in serviceData.hotEmployList" :key="item.employId"
          @click="$router.push(`guide?employId=${item.employId}`)">
          <p>
            <i :class="`el-icon-${item.icon}`"></i>
            <span>{{ item.employName }}</span>
            <span>{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</span>
          </p>
          <div>{{ item.departmentName }}</div>
        </div>
      </div>
      <div class="combine">
        <div class="part new" data-title="最新服务" style="--top:-38px">
          <div id="service" v-for="item in serviceData.newEmployList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}`)">
            <p>
              <i :class="`el-icon-${item.icon}`"></i>
              <span>{{ item.employName }}</span>
              <span>{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</span>
            </p>
            <div>{{ item.departmentName }}</div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="part rec" data-title="推荐服务" style="--top:-38px">
          <div id="service" v-for="item in serviceData.recommendEmployList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}`)">
            <p>
              <i :class="`el-icon-${item.icon}`"></i>
              <span>{{ item.employName }}</span>
              <span>{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</span>
            </p>
            <div>{{ item.departmentName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from './api'
import { collectService } from '../collection/api'
const { jumpURL } = projectConfig
export default {
  name: 'Home',
  data() {
    return {
      isLogin: localStorage.getItem('sys_token'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      serviceData: {},
      userData: {
        todoApplyInfo: {},
        finishedApplyInfo: {},
        userApplyInfo: {},
      },
      activeTitle: 1,
    }
  },
  async created() {
    const { data } = await api.getServiceData({
      roles: this.userRole == 0 ? 2 : this.userRole == 2 ? 1 : this.userRole == 4 ? 3 : ''
    })
    this.serviceData = data
    if (this.isLogin) this.getUserData()
  },
  methods: {
    async getUserData() {
      const { data } = await api.getUserData()
      this.userData = data
    },
    checkMore() {
      if (this.activeTitle === 1) this.$router.push('/task')
      else window.open(jumpURL + '/applyRecord', '_blank')
    },
    async collectService(employId) {
      await collectService(employId)
      this.$message.success('已取消收藏')
      this.getUserData()
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  min-height: calc(100vh - 363px);
  background: #fff;

  .after-login {
    height: 495px;
    width: var(--inner-width);
    background: #fff;
    padding-top: 60px;
    margin: auto;
    display: flex;
    gap: 60px;

    .left {
      background: #fbfbfb;
      flex: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      .title {
        display: flex;
        align-items: flex-start;
        gap: 50px;

        b {
          color: #333;
          font-size: 24px;
          font-weight: bold;
          transition: 300ms;
          cursor: pointer;

          &.active {
            color: $mainColor;
          }
        }

        span {
          margin-left: auto;
          color: $mainColor;
          font-weight: 500;
          cursor: pointer;
        }
      }

      .divider {
        background: $mainColor;
        height: 2px;
        opacity: .5;
      }

      .table {
        flex: 1;
        display: grid;
        grid-template-rows: repeat(7, 1fr);
        align-items: center;
        border-bottom: 1px solid #d9d9d9;

        &-header {
          display: flex;

          b {
            flex: 1;
            color: #666;
            font-size: 18px;
            text-align: center;

            &:first-child {
              text-align: left;
            }

            &:last-child {
              text-align: right;
            }
          }
        }

        &-row {
          display: flex;

          span {
            flex: 1;
            color: #666;
            text-align: center;

            &:first-child {
              text-align: left;

              &::before {
                content: '';
                display: inline-block;
                width: 6px;
                aspect-ratio: 1;
                background: $mainColor;
                border-radius: 50%;
                margin-right: 10px;
                transform: translateY(-2px);
              }
            }

            &:last-child {
              text-align: right;
            }

            &.status {

              b {
                border: 1px solid var(--color);
                font-size: 12px;
                padding: 2px 4px;
                border-radius: 2px;
                color: var(--color)
              }
            }
          }
        }
      }
    }

    .right {
      background: #fbfbfb;
      width: 400px;
      padding: 20px;
      display: grid;
      grid-template-rows: 28px repeat(3, 100px);
      gap: 25px;

      b {
        font-size: 24px;
        color: #333;
      }
    }
  }

  .home-inner {
    width: var(--inner-width);
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 100px;
    padding: 100px 0 60px;

    .part {
      display: grid;
      position: relative;

      &::before {
        content: attr(data-title);
        position: absolute;
        top: var(--top);
        color: #333;
        font-size: 18px;
        font-weight: bold;
      }
    }

    .hot {
      grid-template-columns: repeat(4, 1fr);
      gap: 20px 27px;
    }

    .combine {
      // margin-top: 163px;
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .divider {
        width: 1px;
        background: #d9d9d9;
        margin: 0 20px;
      }

      .new,
      .rec {
        flex: 1;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }
    }
  }
}
</style>